import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMapPin, FiMail } = FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://i.ibb.co/LDyWvysb/logo-fav-icon.jpg" 
                alt="ADRES Turkish Gents Salon" 
                className="h-16 w-auto object-contain"
              />
              <h3 className="text-2xl font-bold">ADRES TURKISH GENTS SALON</h3>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Experience premium men's grooming with traditional Turkish barbering techniques. 
              We provide exceptional haircuts, beard styling, and grooming services in Dubai.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/gallery" className="text-gray-400 hover:text-white transition-colors">Gallery</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-gray-400 mt-1 flex-shrink-0" />
                <p className="text-gray-400 text-sm">
                  Al Raha Building - Shop 4<br />
                  Al Barsha First - Al Barsha<br />
                  Dubai - United Arab Emirates
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-gray-400" />
                <a href="tel:+971504261841" className="text-gray-400 hover:text-white transition-colors">
                  +971 50 426 1841
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} ADRES Turkish Gents Salon. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;